export default __webpack_public_path__ + "resources/icons/d500-00f4.png";